// extracted by mini-css-extract-plugin
module.exports = {"DropdownHolder":"Dropdown_DropdownHolder__3NwKO","Dropdown":"Dropdown_Dropdown__2p7zG","forNav":"Dropdown_forNav__2qbnb"};